export enum Routes {
  SalesRouter = "*",
  InquirySearchPageRouter = "/sales/inquiry/search",
  InquiryDetailPageRouter = "/sales/inquiry/:id/detail",
  ListingSearchPageRouter = "/sales/listing/search",
  ListingDetailPageRouter = "/sales/listing/:id/detail",
}
